import { type Content, DEFAULT_CONTENT } from "~/stores/content";

export const getContentOrDefault= (content?: Content | null) => {
  return content ?? DEFAULT_CONTENT;
};